import React from "react";
import { Link } from "react-router-dom";
import * as DateHelper from "../utils/date.formatter";
import { REACT_APP_MODE } from "../config";
import { Translation } from "react-i18next";
import i18n from "../languages/lang.js";

export default props => {
  const mode = props.mode;
  if (!props.data || props.data.length === 0) {
    return <div className="empty-data">{i18n.t("system.empty_data")}</div>;
  }
  return (
    <Translation>
      {t => (
        <table className="table-list-simple">
          <thead>
            <tr>
              <th>{t("common.phone")}</th>
              <th>{t("common.status")}</th>
              <th>{t("common.response")}</th>
              <th className="last">{t("common.last_location")}</th>
            </tr>
          </thead>
          <tbody>
            {props.data.map(item => {
              const lastEvent =
                item.client_details && Array.isArray(item.client_details)
                  ? item.client_details[0]
                  : null;
              return (
                <tr key={item.key}>
                  <td>
                    <Link to={`/campaigns/items/${item.key}`}>
                      {item.asset_number}
                    </Link>
                  </td>
                  <td>
                    <Link to={`/campaigns/items/${item.key}`}>
                      {t("campaign.item_status_" + item.status.toLowerCase())}
                    </Link>
                  </td>
                  <td>
                    <Link
                      className={`status-${item.client.toLowerCase()}`}
                      to={`/campaigns/items/${item.key}`}
                    >
                      {t(
                        "campaign.item_response_status_" +
                          item.client.toLowerCase()
                      )}
                    </Link>
                  </td>
                  {/* Object.entries(item.client_details.value) */}
                  <td className="last">
                    <Link to={`/campaigns/items/${item.key}`}>
                      {lastEvent
                        ? `lon:${lastEvent.value.longitude}, lat:${lastEvent.value.latitude}`
                        : ""}
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </Translation>
  );
};
